// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"97373b74","97":"20de3359","156":"128e426b","264":"0cb49bff","453":"ea601c8d","945":"9a891196","994":"ace33565"}[chunkId] + ".chunk.js";
};